module.exports = __webpack_public_path__ + "static/media/NATURS.2d62ffc9.svg";